import { render, staticRenderFns } from "./transactionList.vue?vue&type=template&id=60dc823b"
import script from "./transactionList.vue?vue&type=script&lang=js"
export * from "./transactionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports